import { createContext, useContext, useEffect, useState } from "react";

import { iContextProvider } from "shared/ui/interfaces/iContextProvider";

export type iErrorContext = {
  cleanError: () => void;
  throwError: (error: any) => void;
  error: any;
  errorLog: Array<any>;
};

const defaultErrorContextValue: iErrorContext = {
  cleanError: () => {},
  throwError: () => {},
  error: undefined,
  errorLog: [],
};

const useError = () => {
  const [error, setError] = useState<any>();
  const [errorLog, setErrorLog] = useState<Array<any>>([]);

  useEffect(() => {
    if (error) {
      setErrorLog((s: any) => [...s, error]);
    }
  }, [error]);

  const cleanError = () => {
    setError(undefined);
  };

  const throwError = (error: any) => {
    setError(error);
  };

  return { error, cleanError, errorLog, throwError };
};

export default useError;

export const ErrorContext = createContext<iErrorContext>(
  defaultErrorContextValue
);

export const useErrorContext = () => useContext(ErrorContext);

export const ErrorContextProvider: React.FC<iContextProvider> = ({
  children,
  // eslint-disable-next-line react-hooks/rules-of-hooks
  value = useError(),
}: iContextProvider) => {
  return (
    <ErrorContext.Provider value={value}>{children}</ErrorContext.Provider>
  );
};
